var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-collapse",
    {
      staticClass: "cart",
      model: {
        value: _vm.activeSections,
        callback: function($$v) {
          _vm.activeSections = $$v
        },
        expression: "activeSections"
      }
    },
    [
      _vm.user
        ? _c(
            "el-collapse-item",
            { attrs: { name: "customer" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _vm.editable
                    ? _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "your-details",
                              params: { redirect: _vm.$route.name }
                            }
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              size: "mini",
                              icon: "el-icon-edit",
                              circle: "",
                              plain: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v("\n      Your Details\n    ")
                ],
                1
              ),
              _vm._v(" "),
              _c("table", [
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v("Name")]),
                    _c("td", [_vm._v(_vm._s(_vm.customerName))])
                  ]),
                  _vm._v(" "),
                  !_vm.user.is_guest
                    ? _c("tr", [
                        _c("th", [_vm._v("Email")]),
                        _c("td", [_vm._v(_vm._s(_vm.user.email))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Phone")]),
                    _c("td", [_vm._v(_vm._s(_vm.user.phone_number))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Address")]),
                    _c("td", [_vm._v(_vm._s(_vm.customerAddress))])
                  ])
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.order.scenario
        ? _c(
            "el-collapse-item",
            { attrs: { name: "booking" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _vm.editable
                    ? _c(
                        "router-link",
                        { attrs: { to: { name: "booking" } } },
                        [
                          _c("el-button", {
                            attrs: {
                              size: "mini",
                              icon: "el-icon-edit",
                              circle: "",
                              plain: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.order.scenario
                    ? _c("span", [_vm._v(_vm._s(_vm.order.scenario.name))])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("table", [
                _c("tbody", [
                  _vm.order.time
                    ? _c("tr", [
                        _c("th", [_vm._v("When")]),
                        _c("td", [_vm._v(_vm._s(_vm.when))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.order.games
                    ? _c("tr", [
                        _c("th", [_vm._v("Games")]),
                        _c("td", [_vm._v(_vm._s(_vm.order.games))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.order.duration
                    ? _c("tr", [
                        _c("th", [_vm._v("Duration")]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.order.duration) + " minutes")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.order.adults > 0
                    ? _c("tr", [
                        _vm.settings.default_players_type ==
                        "adults_and_juniors"
                          ? _c("th", [_vm._v("Adults")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.settings.default_players_type == "combined"
                          ? _c("th", [_vm._v("Players")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.order.adults))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.settings.default_players_type == "adults_and_juniors" &&
                  _vm.order.juniors > 0
                    ? _c("tr", [
                        _c("th", [_vm._v("Juniors")]),
                        _c("td", [_vm._v(_vm._s(_vm.order.juniors))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.order.promo_code
                    ? _c("tr", [
                        _c("th", [_vm._v("Promo code")]),
                        _c("td", [_vm._v(_vm._s(_vm.order.promo_code))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editable && _vm.timeLeft != null
                    ? _c("tr", [
                        _c("th", [_vm._v("Order Expires In")]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _vm.timeLeft > 0
                              ? _c("countdown", {
                                  attrs: { time: _vm.timeLeft },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(props) {
                                          return [
                                            _vm._v(
                                              _vm._s(props.minutes) +
                                                " minutes, " +
                                                _vm._s(props.seconds) +
                                                " seconds."
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3346544829
                                  )
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.timeLeft <= 0
                              ? _c("div", [_vm._v("Expired")])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("tfoot", [
                  _c("tr", [
                    _c("th", [_vm._v("Sub Total")]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("i18n-n", {
                          attrs: {
                            value: _vm.bowlingAmount,
                            format: "currency"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-collapse-item",
        { attrs: { name: "extras" } },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _vm.editable
                ? _c(
                    "router-link",
                    { attrs: { to: { name: "extras" } } },
                    [
                      _c("el-button", {
                        attrs: {
                          size: "mini",
                          icon: "el-icon-edit",
                          circle: "",
                          plain: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-badge",
                {
                  attrs: { value: _vm.selectedAddonsTotalQty, type: "warning" }
                },
                [_vm._v("\n        Extras\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("table", [
            _c(
              "tbody",
              [
                _vm._l(_vm.selectedAddons, function(addon) {
                  return _vm.editable
                    ? _c("tr", [
                        _c("th", [_vm._v(_vm._s(addon.qty) + " x")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(addon.addon.conqueror_pro_price_key_name)
                          )
                        ]),
                        _c(
                          "td",
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "el-icon-delete",
                                circle: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeAddon(addon.addon)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(_vm.order.selected_add_ons, function(addon) {
                  return !_vm.editable
                    ? _c("tr", [
                        _c("th", [_vm._v(_vm._s(addon.qty) + " x")]),
                        _c("td", [
                          _vm._v(
                            _vm._s(addon.addon.conqueror_pro_price_key_name)
                          )
                        ]),
                        _c("td")
                      ])
                    : _vm._e()
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("tfoot", [
              _c("tr", [
                _c("th", [_vm._v("Sub Total")]),
                _vm._v(" "),
                _vm.editable
                  ? _c(
                      "td",
                      [
                        _c("i18n-n", {
                          attrs: {
                            value: _vm.selectedAddonsTotal,
                            format: "currency"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.editable
                  ? _c(
                      "td",
                      [
                        _c("i18n-n", {
                          attrs: {
                            value: +_vm.order.add_ons_amount,
                            format: "currency"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("td")
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("table", [
        _c("caption", [
          _c("i", { staticClass: "icon el-icon-info" }),
          _vm._v(" Summary")
        ]),
        _vm._v(" "),
        _c("tfoot", [
          _c("tr", [
            _c("th", [_vm._v("Total")]),
            _vm._v(" "),
            _vm.editable
              ? _c(
                  "td",
                  [
                    _c("i18n-n", {
                      attrs: { value: _vm.calculatedTotal, format: "currency" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.editable
              ? _c(
                  "td",
                  [
                    _c("i18n-n", {
                      attrs: {
                        value: +_vm.booking.booking.total_value,
                        format: "currency"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }